// Content extracted from Dheeraj Chawla's resume + LinkedIn.
// Testimonials are polished placeholders — replace with real quotes.

export const PROFILE = {
  name: "Dheeraj Chawla",
  firstName: "Dheeraj",
  lastName: "Chawla",
  title: "Founder & Principal Consultant",
  company: "DNA Digital",
  location: "Delhi NCR, India",
  email: "dj@dheerajchawla.com",
  phone: "+91 99994 50455",
  linkedin: "https://www.linkedin.com/in/djdigitalmarketingexpert/",
  years: "16+",
  tagline:
    "I'm the growth partner consumer & D2C founders bring in when marketing has to pay for itself. Part strategist, part operator — I build the engine, then make it compound.",
  aboutTagline:
    "For 16 years I've sat on both sides of the table — inside global agency groups and as the founder brands call directly. Today I run DNA Digital, advising founders and leadership teams across India, the US, UK, EU and UAE on the growth decisions that actually move revenue.",
  heroImage: "/images/dheeraj-suit.jpeg",
  aboutImage: "/images/dheeraj-nia.jpeg",
  logo: "/images/logo-crop.png",
  calendly: "https://calendly.com/dj-dnadigital/1on1consultation",
};

export const STATS = [
  { prefix: "₹", value: 100, suffix: "Cr+", label: "Revenue generated for brands" },
  { value: 200, suffix: "+", label: "Brands consulted & scaled" },
  { value: 12, suffix: "+", label: "Global markets served" },
  { value: 16, suffix: "+", label: "Years driving growth" },
];

export const VENTURES = [
  {
    name: "SmartDigi",
    role: "Founder",
    url: "https://www.smartdigi.in",
    desc: "A digital marketing venture (LG Group era) driving large-scale brand and demand campaigns across aviation, education and consumer categories.",
  },
  {
    name: "DNA Digital",
    role: "Founder & Principal Consultant",
    url: "https://www.dnadigital.in",
    desc: "My independent growth practice — advising consumer & D2C founders worldwide on brand, performance, ecommerce and retention with 5x–10x ROI.",
  },
  {
    name: "Growth Circle",
    role: "Founder",
    url: "https://www.d32noida.com",
    desc: "A community and advisory platform connecting founders and marketers to compound growth through shared playbooks and peer learning.",
  },
  {
    name: "Trendynest Ecommerce",
    role: "Founder",
    url: "https://www.sungglr.shop",
    desc: "A D2C / ecommerce venture applying the full-funnel playbook first-hand — from marketplace listings and CRO to lifecycle and retention.",
  },
];

export const MARKETS = [
  { name: "India", coordinates: [78.9629, 22.5937], stat: "200+ brands", note: "Home base — DNA Digital HQ", hub: true },
  { name: "United States", coordinates: [-98.5795, 39.8283], stat: "ZeroWater", note: "D2C growth · outperformed BRITA" },
  { name: "Canada", coordinates: [-106.3468, 56.1304], stat: "D2C scale", note: "Cross-border ecommerce growth" },
  { name: "United Kingdom", coordinates: [-2.436, 54.3781], stat: "+19% sales", note: "Cambridge Audio · full-funnel DSP" },
  { name: "United Arab Emirates", coordinates: [53.8478, 23.4241], stat: "5–10x ROI", note: "Consumer & retail campaigns" },
  { name: "Singapore", coordinates: [103.8198, 1.3521], stat: "APAC growth", note: "Regional performance marketing" },
  { name: "Malaysia", coordinates: [101.9758, 4.2105], stat: "Market entry", note: "Consumer brand expansion" },
  { name: "South Africa", coordinates: [24.9375, -29.0], stat: "New market", note: "D2C launch & demand gen" },
  { name: "Germany", coordinates: [10.4515, 51.1657], stat: "6.24x ROAS", note: "Michelin (France) · e-Comas DSP" },
  { name: "France", coordinates: [2.2137, 46.6276], stat: "€44.2K sales", note: "Michelin · Amazon DSP at scale" },
];

export const SIGNATURE_OFFER = {
  tag: "Signature Engagement",
  name: "The 90-Day Growth Sprint",
  promise:
    "A focused, done-with-you engagement to turn marketing into a predictable, compounding growth engine — in one quarter, with the numbers to prove it.",
  price: "Limited to 3 brands per quarter",
  phases: [
    {
      k: "Days 1–15",
      t: "Diagnose",
      d: "Full growth audit — funnel, spend, data and positioning. We find the leaks and the leverage.",
    },
    {
      k: "Days 16–45",
      t: "Rebuild",
      d: "Restructure paid media, listings/CRO and messaging around a single revenue-first plan.",
    },
    {
      k: "Days 46–90",
      t: "Compound",
      d: "Scale what works, layer in retention & lifecycle, and hand over a system your team can run.",
    },
  ],
  outcomes: [
    "A revenue-first growth plan the whole team aligns on",
    "Rebuilt paid & ecommerce engine optimised for ROAS",
    "Attribution & reporting you can take to the board",
    "A retention/lifecycle loop that lifts LTV",
    "Clear next-quarter roadmap and playbook",
  ],
};

export const HERO_LINES = ["Building brands.", "Engineering", "growth."];

export const BRANDS = [
  "HP",
  "GSK",
  "HTC",
  "Carlsberg",
  "Michelin",
  "Cambridge Audio",
  "LG Group",
  "XOLO",
  "ZeroWater",
  "GroupM",
  "Omnicom",
  "IPG Mediabrands",
];

export const SERVICES = [
  {
    n: "01",
    title: "Growth Strategy & Advisory",
    desc:
      "Positioning, category strategy and a full-funnel growth plan — the decisions that decide whether spend compounds or leaks. Board-ready, revenue-first.",
    points: ["Positioning & GTM", "Channel & budget strategy", "Forecasting & attribution"],
  },
  {
    n: "02",
    title: "Performance & Ecommerce",
    desc:
      "Hands-on paid media and marketplace growth across Google, Meta, Amazon DSP and programmatic — engineered for ROAS, not vanity metrics.",
    points: ["Paid media & DSP", "Amazon & marketplace", "Landing & ecommerce CRO"],
  },
  {
    n: "03",
    title: "Fractional CMO / Retainer",
    desc:
      "Senior marketing leadership without the full-time hire — I own the number, build the team and run the operating rhythm alongside your founders.",
    points: ["Team & agency management", "Operating cadence & SOPs", "Executive reporting"],
  },
  {
    n: "04",
    title: "Retention & Lifecycle",
    desc:
      "The unsexy engine that quietly doubles LTV — CRM, WhatsApp, email and lifecycle systems that turn first orders into repeat revenue.",
    points: ["CRM & automation", "Lifecycle & retention", "LTV & repeat-purchase"],
  },
];

export const ENGAGE_STEPS = [
  { n: "01", t: "Discovery call", d: "A focused conversation on where you are, where you want to be, and whether I'm the right partner." },
  { n: "02", t: "Growth audit", d: "I pressure-test your funnel, spend and data, and map the highest-leverage moves." },
  { n: "03", t: "Engagement", d: "Advisory, fractional or hands-on delivery — scoped to your stage and outcomes." },
];

export const IMPACT = [
  {
    n: "01",
    value: "11.4x",
    label: "Marketing ROI, scaled from 3.8x",
    detail:
      "Rebuilt a D2C brand's full-funnel engine — doubling monthly orders and cutting acquisition-cost ratios by 42%.",
  },
  {
    n: "02",
    value: "6.24x",
    label: "ROAS for a French automotive major",
    detail:
      "Programmatic display & Amazon DSP strategy for Michelin (France) delivering efficient, at-scale returns.",
  },
  {
    n: "03",
    value: "+19%",
    label: "Sales uplift for a UK electronics brand",
    detail:
      "Full-funnel media strategy for Cambridge Audio (UK) via DSP and programmatic display.",
  },
  {
    n: "04",
    value: "4,250+",
    label: "Qualified leads → 185 new centre openings",
    detail:
      "B2B & B2C demand-generation across a multi-brand franchise portfolio at a consistent 3x ROI.",
  },
  {
    n: "05",
    value: "$100K+",
    label: "Monthly media budgets managed",
    detail:
      "Across Google, Meta, LinkedIn, Amazon and programmatic — with attribution, forecasting and executive reporting.",
  },
  {
    n: "06",
    value: "5–10x",
    label: "Consistent marketing ROI, sustained",
    detail:
      "Integrated programmes spanning paid media, ecommerce CRO and CRM-led lifecycle marketing across markets.",
  },
];

export const EXPERIENCE = [
  {
    role: "Principal Consultant, Performance Marketing",
    company: "DNA Digital / Independent Practice",
    period: "Sep 2021 — Present",
    points: [
      "Advise consumer & D2C brands across India, US, UK, EU and UAE on brand, digital and growth strategy.",
      "Manage $100K+ monthly media budgets with attribution, forecasting and executive reporting.",
      "Deliver consistent 5x–10x ROI through integrated paid media, CRO and CRM-led lifecycle marketing.",
    ],
  },
  {
    role: "Amazon DSP Expert",
    company: "e-Comas GmbH, Germany (remote)",
    period: "Sep 2021 — Nov 2022",
    points: [
      "Ran programmatic display & DSP strategy for international consumer brands.",
      "Drove a 19% sales uplift for a UK electronics brand and 6.24x ROAS for a French automotive major.",
    ],
  },
  {
    role: "Chief Digital Officer",
    company: "Franchise India",
    period: "Mar 2019 — Aug 2021",
    points: [
      "Enterprise digital leadership across brand, content, social and performance for 100+ brands.",
      "Built scalable B2B & B2C demand-generation engines with CRM, automation and lead scoring.",
      "Led multi-functional teams; instituted SOPs, dashboards and attribution for board-level reporting.",
    ],
  },
  {
    role: "Head, Digital Marketing",
    company: "SMART DIGI (an LG Group company)",
    period: "Mar 2017 — Feb 2019",
    points: [
      "Managed large-scale brand & demand campaigns across aviation, education and consumer categories.",
      "Owned budgets, media mix, agency governance and campaign measurement.",
    ],
  },
  {
    role: "Associate Director",
    company: "Omnicom Media Group",
    period: "Dec 2015 — Sep 2016",
    points: [
      "Led digital planning & performance for HP, GSK, HTC and Carlsberg.",
      "Managed cross-channel budgets and client leadership reviews.",
    ],
  },
  {
    role: "Senior Manager",
    company: "Reprise Digital (IPG Mediabrands)",
    period: "Apr 2015 — Dec 2015",
    points: ["Digital strategy and performance delivery across brand accounts."],
  },
  {
    role: "Digital Manager",
    company: "Mediacom (GroupM)",
    period: "Jan 2014 — Jun 2014",
    points: ["Awarded Best Digital Creative Idea by Google."],
  },
];

export const SKILLS = [
  "Brand Strategy & Integrated Campaigns",
  "Media Planning & A&P Budgets",
  "Performance Marketing (Google, Meta, LinkedIn, Programmatic)",
  "Ecommerce & Conversion Optimization",
  "CRM, Retention & Lifecycle Marketing",
  "Marketing Analytics & Attribution (GA4, GTM)",
  "P&L Ownership & Commercial Acumen",
  "Team Leadership & Capability Building",
];

export const CERTS = [
  "Amazon DSP Advanced",
  "Amazon Sponsored Ads",
  "Google Ads Certified",
  "Google Analytics Certified",
  "The Trade Desk Academy",
];

export const TESTIMONIALS = [
  {
    quote:
      "Working with DNA Digital on STIM was a very positive experience. The team was proactive, responsive, and genuinely invested in the brand's growth. They helped us scale performance significantly, improving ROAS to 8 within the first 3 months and further elevating it to 11.4 over the following 8 months. It was a pleasure working with a team that combined strategy with action.",
    name: "Viren Khuller",
    role: "Director, STIM",
  },
  {
    quote:
      "DNA Digital both designed and executed a programme that catapulted visibility of the Analytics Hive brand to levels that we never imagined previously. Furthermore, we started getting higher quality in-bound leads which enriched our opportunity pipeline immensely.",
    name: "Justice Chikomba",
    role: "Analytics Hive",
  },
  {
    quote:
      "Over two years, DJ mastered Amazon DSP, Google Ads, Meta Ads, Google Shopping, and Bing campaigns, consistently delivering outstanding performance for E-Comas. A true Digital Marketing Arts expert and a pleasure to work with.",
    name: "Anders Hjorth",
    role: "e-Comas, Germany",
  },
  {
    quote:
      "Thanks to DNA's expertise in paid marketing and organic posting, our business coaching firm has experienced a remarkable boost in visibility and engagement. Their strategic approach is a game-changer — highly recommended!",
    name: "Satyam Garg",
    role: "ActionCoach India",
  },
  {
    quote:
      "DJ with the DNA crew is a great, reactive, friendly and efficient team — very complete with many different types of knowledge and competencies, offering a very 'sharp' Swiss-knife of digital media practices. We would certainly recommend DJ to anyone looking for a performing team.",
    name: "Jérôme de Guigné",
    role: "e-Comas, Germany",
  },
  {
    quote:
      "Kudos to the DNA team for outstanding social media management! Their strategic approach elevated our brand image, and the seamless collaboration with DNA's professionalism is truly appreciated.",
    name: "Bibin",
    role: "India Designer Show",
  },
];

export const CASE_STUDIES = [
  {
    n: "01",
    client: "STIM",
    category: "Ecommerce · Amazon",
    headline: "11.4x ROAS, tripled in 8 months",
    challenge:
      "Low organic visibility from poor listings and SEO, high ACOS from inefficient campaigns, and weak product-page engagement.",
    approach:
      "Revamped listings with optimized keywords and interactive A+ content, then restructured underperforming ad campaigns around high-intent keywords and efficient budgets.",
    metrics: [
      { v: "11.4x", l: "ROAS (from 3.8x)" },
      { v: "+68%", l: "Revenue — ₹14.7L → ₹24.7L" },
      { v: "2x", l: "Orders — 4,819 → 10,092" },
      { v: "8.8%", l: "TACOS (from 15.3%)" },
    ],
  },
  {
    n: "02",
    client: "Cambridge Audio",
    category: "Ecommerce · Amazon DSP",
    headline: "Proved DSP drove 81% of sales",
    challenge:
      "Long purchase cycles for high-value products meant Amazon DSP looked low-ROAS and was at risk of being cut — despite its hidden full-funnel impact.",
    approach:
      "Full-funnel DSP + Sponsored Ads mix, using Amazon Marketing Cloud to map shopper journeys and prove DSP's role in initiating intent and driving branded search.",
    metrics: [
      { v: "81%", l: "Of sales influenced by DSP" },
      { v: "+19%", l: "Uplift in overall sales" },
      { v: "+48%", l: "Increase in customer base" },
      { v: "38K", l: "Branded searches in 21 months" },
    ],
  },
  {
    n: "03",
    client: "Michelin France",
    category: "Ecommerce · Amazon DSP",
    headline: "6.24x ROAS, premium at scale",
    challenge:
      "Scale beyond Sponsored Ads profitably while protecting Michelin's premium positioning in France.",
    approach:
      "Activated Amazon DSP with audience targeting and remarketing, with weekly optimization and balanced budget allocation for sustainable, profitable scale.",
    metrics: [
      { v: "6.24x", l: "ROAS on spend" },
      { v: "€44.2K", l: "Total sales" },
      { v: "€7.1K", l: "Total ad cost" },
      { v: "6x+", l: "Return validating DSP long-term" },
    ],
  },
  {
    n: "04",
    client: "Education Brands — India Expansion",
    category: "Franchise · Lead Generation",
    headline: "4,250+ leads → 185 centers opened",
    challenge:
      "Low visibility in a competitive education market and difficulty attracting qualified investors and franchise partners.",
    approach:
      "Built a lead-generation engine (performance + SEO), conversion-focused investor webinars and pitch funnels, plus market targeting and launch support for faster rollout.",
    metrics: [
      { v: "4,250+", l: "Leads generated" },
      { v: "185", l: "Centers opened" },
      { v: "3x", l: "ROI within 18 months" },
      { v: "-40%", l: "Churn via quality targeting" },
    ],
  },
];

export const EXTRA_CASES = [
  {
    client: "ZeroWater",
    category: "Ecommerce · Amazon DSP",
    headline: "Outperformed BRITA on conversion",
    challenge:
      "Win high-intent shoppers away from a dominant incumbent (BRITA) and prove immediate DSP performance.",
    approach:
      "Retargeted high-intent users who visited ZeroWater or competitor pages via Amazon DSP, positioned messaging around ZeroWater's edge over BRITA, and optimized bids in real time against ROAS.",
    metrics: [
      { v: "1st mo.", l: "ROAS target achieved" },
      { v: "#1", l: "Outperformed BRITA on conversion" },
      { v: "DSP", l: "Precise high-intent targeting" },
    ],
  },
  {
    client: "Korean Air",
    category: "Social Media Marketing",
    headline: "8.2M impressions, 250 leads",
    challenge:
      "Close brand gaps and drive engagement and lead capture across diverse audiences.",
    approach:
      "Built a creative campaign with precise Facebook Ads targeting across demographics, tracking performance to continually optimize awareness and engagement.",
    metrics: [
      { v: "8.2M", l: "Impressions" },
      { v: "122K", l: "Ad clicks" },
      { v: "250", l: "Leads captured" },
      { v: "1.5%", l: "Click-through rate" },
    ],
  },
  {
    client: "Numero Uno",
    category: "Branding & Awareness",
    headline: "Reinvigorated brand recall",
    challenge:
      "Reinvigorate an established brand and lift perception, recall and engagement.",
    approach:
      "Ran a brand audit and consumer-insight study, co-developed a fresh identity and narrative, and rolled it out across social, email and digital media for maximum reach.",
    metrics: [
      { v: "+30%", l: "Social media engagement" },
      { v: "+25%", l: "Website traffic" },
      { v: "+15%", l: "Brand perception & recall" },
    ],
  },
];
